module.exports = __webpack_public_path__ + "img/icon@2x(6).198f2fe9.png";